import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchPackingHouseProcess(packing_house_process_id) {
    return RequesterV1.get(
      `packing_house/process/harvested_batches/show_process/${packing_house_process_id}`
    );
  }
};
